import React, { useEffect, useState } from 'react';
import PageTitle from '../components/pagetitle/PageTitle';

import Footer from '../components/footer';
import Collection03 from '../components/collection/Collection03';
import dataCollection from '../assets/fake-data/data-collection';
import { Link, useParams } from 'react-router-dom';
import coins from '../assets/images/icon/icon-bonus.webp'
import { formateCoins, promotion } from '../function';

import img from '../assets/images/item-details.jpg'
import { fatchOffers, getAllTypeOffers, getOfferById } from '../services/offers/offersApi';
import { toast, ToastContainer } from 'react-toastify';
import PaymentModal from '../components/PaymentModal';
import { getStock } from '../services/stock/stockApi';
import { useTranslation } from 'react-i18next';
import { useCurrency } from '../context/CurrencyContext';

function ItemDetails(props) {
    const { t } = useTranslation();
    const { formatPrice, currency } = useCurrency();
    const [offer, setOffer] = useState({
        id: 0,
        coins: 0,
        type_id: 0,
        montant: 0,
        promotion: 0,
    })
    const [typeOffers, setTypeOffers] = useState([]);
    const [offers, setOffers] = useState([]);
    const { id } = useParams()
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [stock, setStock] = useState([]);

    const getOffers = async () => {
        await fatchOffers("", 10, 1)
            .then((response) => {
                setOffers(response.data.offres);
            })
            .catch((error) => {
                toast.error(t('api error'));
            });
    }


    useEffect(() => {
        getAllTypeOffers()
            .then(res => {
                setTypeOffers(res.data)
            })
            .catch(err => {
                console.log(err)
            })

        getOffers()

        getOfferById(id)
            .then(res => {
                setOffer(res.data.offre)
                return res.data.offre.type_id
            })
            .then(type => {

                getStock(type)
                    .then((response) => {

                        setStock(response.data.total_amount);
                    })
                    .catch((error) => {
                        toast.error(t('api error'));
                    });

            })
            .catch(err => {
                console.log(err)
            })
    }, [])

    const openModal = () => {
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };

    return (
        <div className='page-collection'>

            <PageTitle title={t('item details')} />

            <section className=" tf-item-detail" >
                <div className="tf-container" style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>

                    <div className="tf-product tf-home-product" style={{ width: "50%" }}>


                        <div className="tf-item-detail-inner my-package row" style={{ display: "flex", justifyContent: "center", alignItems: "center", marginLeft: "0px !important" }}>

                            <h2 className="title"><img src={coins} width={35} /> <span className='ml-2'>{formateCoins(offer.coins)} {t('coins')}</span></h2>


                            <div style={{ textAlign: "center", marginBottom: '20px' }} >
                                <div className="infor-item-box"  >
                                    <div className="category">{t('type')}</div>
                                    <h4 className="name">{typeOffers.find(t => t.id === offer.type_id)?.nom ?? ""}</h4>
                                </div>

                            </div>
                            <div className="price">
                                <span className="heading">{t('price')}:</span>
                                <span>{`${formatPrice(promotion(offer.montant, offer.promotion))} ${currency}`}{(offer.promotion !== null && offer.promotion > 0) && <span style={{ textDecoration: 'line-through', textAlign: 'center' }} class="strike-text ml-3">{formatPrice(offer.montant)} {currency}</span>}</span>
                            </div>


                            <div className="group-btn"  >
                                <button disabled={!offer.coins || stock < offer.coins} onClick={openModal} className="tf-button opensea" style={{ marginRight: "10px !important", backgroundColor: stock < offer.coins ? "#ccc" : "", cursor: stock < offer.coins ? "not-allowed" : "pointer" }}><i className="icon-fl-bag"></i> {t('BUY')}</button>

                            </div>

                        </div>
                    </div>

                </div>
            </section>

            <PaymentModal isOpen={isModalOpen} onClose={closeModal} offre={offer} />
            <ToastContainer draggable />

            <Footer />

        </div>
    );
}

export default ItemDetails;